import { CurrentMoment } from '../../CurrentMoment';
import type { ColorPalette } from '../../ColorPalette';
import { AbstractScheduleEvent } from './AbstractScheduleEvent';

/**
 * Daily time-only schedule event (anchor: time_only).
 */
export class DailyScheduleEvent extends AbstractScheduleEvent {
	constructor(
		private readonly time: string,
		colorPalette: ColorPalette,
		private readonly timezone: string | null
	) {
		super(colorPalette);
	}

	getLatestScheduleEvent(): Date {
		return CurrentMoment.lastDailyScheduleAt(this.time, this.timezone);
	}

	getNextBoundaryAfter(): number | null {
		return CurrentMoment.nextDailyBoundaryMs(this.time, this.timezone);
	}
}
